import { render, staticRenderFns } from "./WhitelistEditDetails.vue?vue&type=template&id=0fade7ae&scoped=true&"
import script from "./WhitelistEditDetails.vue?vue&type=script&lang=js&"
export * from "./WhitelistEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fade7ae",
  null
  
)

export default component.exports